module.exports = "pegasus/assets/blocks/column-11-theme5.png";